import React from "react";
import { useSelector } from "react-redux";
import {
  convertToRGBAString,
  generateFinalPage,
  renderSmile,
} from "utils/helperFunctions";
import { fontSize, smileySizes } from "utils/CONSTANTS";

const FinalPageModel = React.memo(({ data }) => {
  const {
    feedbackArray,
    uid,
    sessions: { [uid]: session },
    selectedLanguage,
  } = useSelector((state) => state);
  const rate = session?.rate || generateFinalPage({ feedbackArray });

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: 20,
        gap: 20,
        // background: data[rate].text_color
        //   ? convertToRGBAString(data[rate].page_bg)
        //   : "unset",
      }}
    >
      {/* <LogoComponent
        source={json.data.general_settings.logo_url}
        size={json.data.general_settings.logo_size || "M"}
      /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 50,
          gap: 40,
        }}
      >
        {data.show_smile && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: smileySizes[data[rate].text_size],
              height: smileySizes[data[rate].text_size],
              fontSize: smileySizes[data[rate].text_size],
              color: convertToRGBAString(data[rate].text_color),
            }}
          >
            {renderSmile(rate)}
          </div>
        )}
        <span
          style={{
            color: convertToRGBAString(data[rate].text_color),
            backgroundColor: convertToRGBAString(
              data[rate].text_bg_color || [255, 255, 255, 0]
            ),
            fontSize: fontSize[data[rate].text_size],
            borderRadius: 8,
            padding: 10,
            textAlign: "center",
          }}
        >
          {data[rate].text[selectedLanguage]}
        </span>
      </div>
    </div>
  );
});

export default FinalPageModel;
